<template>
  <!--    <BasicLayout>-->
  <el-container style="padding: 0px" v-loading.fullscreen.lock.body="loading" element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <el-aside width="240px">
      <el-row type="flex" justify="start" align="middle" class="topTab" @click.native=""><span>资料群发</span></el-row>
      <el-row type="flex" justify="start" align="middle" :class="{ options: true, optionsActive: active == 1 }"
        @click.native="calendar1('1')"><span>任务明细</span></el-row>
      <el-row type="flex" justify="start" align="middle" :class="{ options: true, optionsActive: active == 2 }"
        @click.native="calendar1('2')"><span>医生清单</span></el-row>
    </el-aside>
    <el-main>
      <el-row class="navRouter">
        <span @click="handleBackClick">资料群发</span><span>></span> <span style="color: #3998f7;">{{pageName}}</span>
      </el-row>
      <el-row :span="24" style="border-bottom: 2px dashed #dcdfe6;">
        <el-col :span="18">
          <div style="color: #3998f7; font-size: 20px;font-family: Hiragino Sans GB;line-height: 60px;">
            {{bulkSendInfo.task_name}}&nbsp;
          </div>
        </el-col>
        <el-col :span="6">
          <el-button type="danger" @click="handleBackClick" style="float: right; margin-left: 10px;">返回</el-button>
          <el-button type="primary" @click="handleSaveClick" style="float: right;margin-left: 10px;"
            v-if="bulkSendInfo.status!='ACTIVE'">保存
          </el-button>
          <el-button type="warning" @click="handleSendClick" style="float: right;"
            v-if="active==1 && bulkSendInfo.status!='ACTIVE'">群发</el-button>
          <el-button type="primary" @click="handleAddHcpClick" style="float: right;margin-left: 10px;"
            v-if="active==2 && bulkSendInfo.status!='ACTIVE'">
            添加
          </el-button>
        </el-col>
      </el-row>

      <el-row style="margin-top:30px;margin-left: 10px;" v-if="active == 1">
        <el-col>
          <el-form ref="form" label-width="120px" label-position="left" class="myElForm demo-ruleForm"
            :model="bulkSendInfo" :rules="rule" hide-required-asterisk>
            <el-row>
              <el-col :span="24">
                <el-form-item label="任务名称" prop="task_name" class="upload_star">
                  <el-input v-model="bulkSendInfo.task_name" maxlength="50"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="发送资料" prop="material_array">
                  <el-select style="width: 100%" v-model="bulkSendInfo.material_id" placeholder="请选择">
                    <el-option v-for="item in material_array" :key="item.material_id" :label="item.title"
                      :value="item.material_id"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="发送话术" prop="script" class="upload_star">
                  <el-input type="textarea" maxlength="200" v-model="bulkSendInfo.script"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="状态">
                  <el-radio-group v-model="bulkSendInfo.status" :disabled="true">
                    <el-radio label="INACTIVE">未发送</el-radio>
                    <el-radio label="ACTIVE">已发送</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>

      <el-row style="margin-top:30px;" v-if="active == 2">
        <el-col :span="24">
          <el-table :header-cell-style="{'color':'black','font-size':'15px'}" :data="bulkSendInfo.hcp_array" border
            style="width: 100%;margin-top: 20px" stripe>
            <el-table-column type="index" width="50">
            </el-table-column>
            <el-table-column prop="institution_name" label="医院" min-width="150"> </el-table-column>
            <el-table-column prop="pro_title" label="科室" min-width="100"> </el-table-column>
            <el-table-column prop="job_title" label="职称" min-width="150"> </el-table-column>
            <el-table-column prop="dept_name" label="职务" min-width="100"> </el-table-column>
            <el-table-column prop="hcp_name" label="姓名" min-width="100"> </el-table-column>
            <el-table-column label-class-name="conference_table_cell" fixed="right" label="操作" width="80"
              style="color: #3b99f7">
              <template slot-scope="scope">
                <el-button type="danger" size="small" @click="handleDelete(scope.row)"
                  v-if="scope.row.status!='ACTIVE'">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          </el-dialog>
        </el-col>
        <el-row :span="24" style="margin-bottom:20px; display: none;">
          <el-col :span="24" style="margin-bottom:20px">
            <pagination :page="page" @changePage="changePageClick"></pagination>
          </el-col>
        </el-row>
      </el-row>

    </el-main>

    <el-dialog :visible.sync="showModal_hcp" :show-close="false" width="900px" style="margin-top: -20px">
      <div slot="title">
        <div slot="title" class="dialog-footer" style="display: flex; justify-content: space-between">
          <span style="color: #3998f7; font-size: 22px">HCP列表</span>
          <span>
            <el-button type="primary" size="small" @click="handleSubmitHcpClick">确定</el-button>
            <el-button type="danger" size="small" @click="showModal_hcp = false">关闭</el-button>
          </span>
        </div>
      </div>

      <el-form label-width="120px">
        <el-row>
          <el-row>
            <el-col :span="12">
              <span style="font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">职称
              </span>
              <el-select v-model="searchForm.pro_title_id" placeholder="请选择职称" style="width: calc(100% - 120px)"
                clearable>
                <el-option v-for="item in pro_array" :key="item.key" :label="item.title" :value="item.key">
                </el-option>
              </el-select>

            </el-col>
            <el-col :span="12" style="text-align: right">
              <span style="font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">职务
              </span>
              <el-select v-model="searchForm.job_title_id" placeholder="请选择职务" style="width: calc(100% - 120px)"
                clearable>
                <el-option v-for="item in job_array" :key="item.key" :label="item.title" :value="item.key">
                </el-option>
              </el-select>

            </el-col>

          </el-row>
          <el-row style="margin-top: 20px">
            <el-col :span="12">
              <span style="font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">工作单位</span>
              <el-input type="text" v-model="searchForm.institution_name" placeholder="请输入工作单位"
                style="width:calc(100% - 120px)">
              </el-input>
            </el-col>
            <el-col :span="12" style="text-align: right">
              <span style="font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">科室
              </span>
              <el-input type="text" v-model="searchForm.department" placeholder="请输入工作科室"
                style="width:calc(100% - 120px)">
              </el-input>
            </el-col>
          </el-row>
        </el-row>
      </el-form>
      <div style="display: flex; justify-content: flex-end; margin-top: 20px;">
        <span>
          <el-button type="warning" size="small" @click="handleSearchHcpClick">查询</el-button>
        </span>
      </div>
      <el-row :span="24">
        <el-col>
          <el-table :header-cell-style="{'color':'black','font-size':'15px'}" :data="hcp_array" border
            style="width: 100%;margin-top: 20px" stripe @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column prop="institution_name" label="医院" min-width="150"> </el-table-column>
            <el-table-column prop="job_title" label="科室" min-width="100"> </el-table-column>
            <el-table-column prop="pro_title" label="职称" min-width="150"> </el-table-column>
            <el-table-column prop="dept_name" label="科室" min-width="100"> </el-table-column>
            <el-table-column prop="hcp_name" label="姓名" min-width="100"> </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row :span="24" style="margin-bottom:20px">
        <el-col>
          <pagination :page="page_hcp" @changePage="changeHcpPageClick"></pagination>
        </el-col>
      </el-row>
    </el-dialog>
  </el-container>
  <!--    </BasicLayout>-->
</template>

<script>
  import axios from "axios";
  import http from "../../APIService/http";
  import moment from 'moment'
  import pagination from "../../components/pagination";
  import { MessageBox, Message } from 'element-ui'

  export default {
    name: "bulk_detail",
    components: {
      pagination
      // BasicLayout
    },
    data() {
      return {
        loading: false,
        rule: {
          task_name: [{ required: true, trigger: "blur", message: "此项不能为空" }],
        },
        form: {
          task_id:""
        },
        page: this.GLOBAL.page_bulk_send,
        page_hcp: this.GLOBAL.page_bulk_send_hcp,
        searchForm: {
          pro_title_id: "", // 职称名称
          job_title_id: "",  //职务名称
          institution_name: "",  //机构名称
          department: "" //科室
        },
        bulkSendInfo: {
          task_name: "",
          material_id: "",
          script: "",
          status: "INACTIVE",
          hcp_array: [],
        },
        hcp_array: [],
        multipleSelection: [],
        material_array: [],
        pro_array: [],
        job_array: [],
        active: 1,
        options: [],
        pageName: "任务明细",

        showModal_hcp: false
      };
    },
    created() {
      this.clientObj = this.$store.getters.getClient;
      // console.log(this.$store.getters.getClient,111)
      this.active = 1;

      this.page_hcp = {
        total: 0,
        size: 5,
        current: 1
      }
      this.hcp_array = [];
      this.getBaseTypeArray("HCP_JOB_TITLE");
      this.getBaseTypeArray("HCP_PRO_TITLE");
      this.getMaterialArray();
    },
    mounted() {
      // this.getManager()
      debugger;
      this.form = this.$route.params.row;
      if (this.form) {
        this.init();
      }
    },
    watch: {

    },
    methods: {
      fomartHM(dt) {
        return moment(dt).format("HH:mm")
      },
      async getBaseTypeArray(type) {
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            type: type
          };
          await http.post('/crm/dictionary/getDictionaryByType', data).then(res => {
            debugger;
            if (res.success === true) {
              if (type == "HCP_JOB_TITLE") {
                this.job_array = res.data;
              } else if (type == "HCP_PRO_TITLE") {
                this.pro_array = res.data;
              }
            }
          })
        } catch (e) {
          Message({
            type: "error",
            message: "请返回重新选择",
          });
        } finally {
        }
      },
      async getMaterialArray() {
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id
          };
          await http.post('/echo/webLibrary/getMaterialArray', data).then(res => {
            debugger;
            if (res.success === true) {
              this.material_array = res.data;
            }
          })
        } catch (e) {
          Message({
            type: "error",
            message: "获取资料失败",
          });
        } finally {
        }
      },
      async init() {
        this.loading = true;
        try {
          let user = this.$store.getters.getUser
          let data = {
            tenant_id: user.tenant_id,
            task_id: this.form.task_id
          }
          await http.post('/echo/web/material_bulk/getBulkSendByTaskId', data).then(res => {
            this.loading = true;
            debugger;
            if (res.success === true) {

              this.bulkSendInfo = res.data;

            }
          })
        } catch (e) {
          this.loading = false;
          Message({
            type: "error",
            message: "请返回重新选择",
          });
        } finally {
          this.loading = false;
        }
      },
      handleDelete(row) {
        let index = this.bulkSendInfo.hcp_array.findIndex((e) => e.hcp_id === row.hcp_id);
        this.bulkSendInfo.hcp_array.splice(index, 1);
      },
      handleBackClick() {
        this.$router.back();
      },
      async handleSaveClick() {
        this.saveTask("INACTIVE");
      },
      async handleSendClick() {
        let library_id = this.material_array.length > 0 ? this.material_array[0].library_id : "";
        let material = this.material_array.find(e => e.material_id === this.bulkSendInfo.material_id);
        console.log(material);
        if (!(material && material.versions && material.versions.length > 0)) {
          this.$message({
            type: "error",
            message: "请选择要发送的文件",
          });
          return;
        }
        if (!this.bulkSendInfo.hcp_array || this.bulkSendInfo.hcp_array.length == 0) {
          this.$message({
            type: "error",
            message: "请选择要发送的医生",
          });
          return;
        }
        this.saveTask("ACTIVE");
      },
      async saveTask(status) {
        if(this.bulkSendInfo.task_name=="")
        {
          this.$message({
            type: "error",
            message: "请填写任务名称",
          });
          return;
        }
        let file_id = "";
        let library_id = this.material_array.length > 0 ? this.material_array[0].library_id : "";
        let material = this.material_array.find(e => e.material_id === this.bulkSendInfo.material_id);
        console.log(material);
        if (material && material.versions && material.versions.length > 0) {
          file_id = material.versions[0].file_id;
        }
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          user_id: this.$store.getters.getUser.user_id,
          task_id: this.form ? this.form.task_id : "",
          status: status,
          task_name: this.bulkSendInfo.task_name,
          library_id: library_id,
          material_id: this.bulkSendInfo.material_id,
          file_id: file_id,
          script: this.bulkSendInfo.script,
          hcp_array: this.bulkSendInfo.hcp_array
        }
        console.log(data)
        await http.post('/echo/web/material_bulk/saveBulkSend', data).then(res => {
          if (res.success === true) {
            this.$message({
              type: "success",
              message: "保存成功",
            });
            this.$router.back();
          }
          this.loading = false;
        })
      },
      handleAddHcpClick() {
        this.getHcpList();
        this.showModal_hcp = true;
      },
      async getHcpList() {
        try {
          this.loading = true;
          let user = this.$store.getters.getUser
          let data = {
            tenant_id: user.tenant_id,
            job_title_id: this.searchForm.job_title_id,
            pro_title_id: this.searchForm.pro_title_id,
            department: this.searchForm.department,
            institution_name: this.searchForm.institution_name,
            limit: this.page_hcp.size,
            offset: this.page_hcp.current - 1
          }
          console.log(data);
          await http.post('/crm/web/institution/getInstutionsHcpList_kyc', data).then(res => {
            if (res.success === true) {

              this.hcp_array = res.data.array;
              this.page_hcp.total = parseInt(res.data.total);
            }
            this.loading = false;
          })
        } catch (e) {
          this.loading = false;
          Message({
            type: "error",
            message: "请返回重新选择",
          });
        } finally {
        }
      },
      changePageClick(e) {
        this.page_hcp.current = e;
        this.getHcpList();
      },
      changeHcpPageClick(e) {
        this.page_hcp.current = e;
        this.getHcpList();
      },
      //弹窗 保存选择的hcp
      handleSubmitHcpClick() {
        for (let i = 0; i < this.multipleSelection.length; i++) {
          const tempHcp = this.multipleSelection[i];
          if (!this.bulkSendInfo.hcp_array.find(e => e.hcp_id == tempHcp.hcp_id)) {
            this.bulkSendInfo.hcp_array.push(tempHcp);
          }
        }
        this.page.total = this.bulkSendInfo.hcp_array.length;
        this.showModal_hcp = false;
      },
      //查询hcp
      handleSearchHcpClick() {
        this.getHcpList();
      },
      //选择的hcp
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      calendar1(tav) {
        this.active = tav;
        if (tav == 1) {

        } else if (tav == 2) {

        }

      }
    },
    beforeRouteLeave(to, from, next) {
      localStorage.setItem("active", 1);

      next();
    },
    beforeRouteUpdate(to, from, next) {
      if (to.name === "calendarTable") {
        this.active = 1;
      }
      next();
    },
  };
</script>

<style scoped>
  .topTab {
    font-size: 18px;
    height: 60px;
    padding-left: 40px;
    color: #bbbbbb;
  }

  .el-aside {
    background: #f4f6f8;
    padding: 15px 0;
    /*border: 1px solid #DCDFE6;*/
  }

  .el-main {
    background: white;
    /*border: 1px solid #DCDFE6;*/
    border-left: none;
    padding: 34px 20px 10px;
  }

  .options {
    cursor: pointer;
    height: 45px;
    font-family: "Hiragino Sans GB";
    font-size: 16px;
    color: #323232;
    padding-left: 70px;
    user-select: none;
  }


  .optionsActive {
    cursor: pointer;
    height: 45px;
    font-family: Hiragino Sans GB;
    font-size: 16px;
    color: #323232;
    padding-left: 70px;
    user-select: none;
    color: #3998f7;
    font-weight: bold;
  }

  .el-container {
    min-height: 100%;
  }

  .navRouter {
    cursor: pointer;
    height: 40px;
    font-family: Hiragino Sans GB;
    font-size: 16px;
    color: #323232;
    margin-left: 10px;
  }

  .navRouter span {
    margin-right: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/pages/echo/library_bulk_detail.vue